import { useRef, useState } from "react";

export default function GoogleReviewSlider({ children, length }) {

    const [slide, setSlide] = useState(0);

    const ref = useRef<HTMLDivElement>();
    const refC = useRef<HTMLDivElement>();

    const [point, setPoint] = useState(0);

    let maxScrollLeft = (ref?.current?.scrollWidth ?? 15) - (ref?.current?.clientWidth ?? 0)

    const scroll = (slider: number) => {

        maxScrollLeft = (ref?.current?.scrollWidth ?? 15) - (ref?.current?.clientWidth ?? 0)

        let newSlide = slider;

        ref.current.scroll({
            top: 0,
            left: newSlide,
            behavior: 'smooth'
        });
    }

    const onScroll = () => {
        setSlide(ref?.current?.scrollLeft ?? 0)
    }

    return (
        <>
            <div ref={refC} className="google-reviews__container relative">
                <div className={`google-reviews__arrow left ${slide > 0 && 'show'}`} onClick={() => { scroll(ref.current?.clientWidth + 25 - ((ref.current?.clientWidth + 25) * 2)); setPoint(old => old - 1) }}>
                    <div className="control"><Circle /><Arrow /></div>
                </div>
                <div className={`google-reviews__arrow right ${slide < maxScrollLeft - 10 && 'show'}`} onClick={() => { scroll(ref.current?.clientWidth + 25); setPoint(old => old + 1) }}>
                    <div className="control"><Circle /><Arrow /></div>
                </div>
                <div ref={ref} onScroll={onScroll} className="relative scrollbar-hide overflow-hidden flex gap-8">
                    {children}
                </div>
            </div>
            <div className="bottom-control flex gap-2 justify-center">
                <div>
                    <div className={`bottom-control__button left ${slide > 0 && 'show'}`} onClick={() => { scroll(ref.current?.clientWidth + 25 - ((ref.current?.clientWidth + 25) * 2)); setPoint(old => old - 1) }}><Circle /><Arrow /></div>
                </div>
                <div className="bottom-control__desktop flex gap-2">
                    {Array.from(Array(Math.ceil(length / 3))).map((_, i) =>
                        <div className={`cursor-pointer rounded-full w-3 h-3 border-gray-500 border-2 border-opacity-30 ${point == i ? 'bg-black' : 'bg-white'}`} onClick={() => { scroll(i * (refC?.current.scrollWidth - 24)); setPoint(i) }} />
                    )}
                </div>
                <div className="bottom-control__tablet flex gap-2">
                    {Array.from(Array(Math.ceil(length / 2))).map((_, i) =>
                        <div className={`cursor-pointer rounded-full w-3 h-3 border-gray-500 border-2 border-opacity-30 ${point == i ? 'bg-black' : 'bg-white'}`} onClick={() => { scroll(i * (refC?.current.scrollWidth - 24)); setPoint(i) }} />
                    )}
                </div>
                <div className="bottom-control__phone flex gap-2">
                    {Array.from(Array(Math.ceil(length / 1))).map((_, i) =>
                        <div className={`cursor-pointer rounded-full w-3 h-3 border-gray-500 border-2 border-opacity-30 ${point == i ? 'bg-black' : 'bg-white'}`} onClick={() => { scroll(i * (refC?.current.scrollWidth - 16)); setPoint(i) }} />
                    )}
                </div>
                <div>
                    <div className={`bottom-control__button right ${slide < maxScrollLeft - 10 && 'show'}`} onClick={() => { scroll(ref.current?.clientWidth + 25); setPoint(old => old + 1) }}><Circle /><Arrow /></div>
                </div>
            </div>
        </>
    )
}

const Arrow = () => (
    <svg id="arrow" width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.115184 1.45302C0.115184 0.56212 1.19233 0.115952 1.82229 0.745917L8.40247 7.3261C8.793 7.71662 8.79299 8.34979 8.40247 8.74031L1.82229 15.3205C1.19232 15.9505 0.115182 15.5043 0.115182 14.6134L0.115184 1.45302Z" fill="#233638" />
    </svg>

)

const Circle = () => (
    <svg id="ciricle" width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="26" cy="26" r="26" transform="rotate(-180 26 26)" fill="#416267" fill-opacity="0.13" />
    </svg>

)